import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const SALES_TABS = ["calendar", "trend", "breakdown", "customers"];
export const SALES_SERVICES = ["all", "trademark", "patent", "design", "other"];
export const SALES_PERIODS = ["month", "all", "custom"];
export const SALES_CUSTOMER_SORTS = ["gross", "net", "count", "last_paid_at"];

const MIN_YEAR = 2000;
const MAX_YEAR = 2100;
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

const parseYear = (value) => {
  const n = parseInt(value, 10);
  return n >= MIN_YEAR && n <= MAX_YEAR ? n : null;
};

const useSalesFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const now = new Date();

  const tabParam = searchParams.get("tab");
  const tab = SALES_TABS.includes(tabParam) ? tabParam : "calendar";

  const serviceParam = searchParams.get("service");
  const service = SALES_SERVICES.includes(serviceParam) ? serviceParam : "all";

  const year = parseYear(searchParams.get("year")) ?? now.getFullYear();

  const monthParam = parseInt(searchParams.get("month"), 10);
  const month = monthParam >= 1 && monthParam <= 12 ? monthParam : now.getMonth() + 1;

  const compareParam = searchParams.get("compare");
  let compareMode = "prev";
  let compareYear = year - 1;
  if (compareParam === "none") {
    compareMode = "none";
    compareYear = null;
  } else if (compareParam === "pick") {
    compareMode = "pick";
    compareYear = null;
  } else if (parseYear(compareParam) !== null) {
    compareMode = "pick";
    compareYear = parseYear(compareParam);
  }

  const periodParam = searchParams.get("period");
  const period = SALES_PERIODS.includes(periodParam) ? periodParam : "all";
  const startParam = searchParams.get("start") || "";
  const endParam = searchParams.get("end") || "";
  const startDate = DATE_RE.test(startParam) ? startParam : "";
  const endDate = DATE_RE.test(endParam) ? endParam : "";

  const sortParam = searchParams.get("sort");
  const sort = SALES_CUSTOMER_SORTS.includes(sortParam) ? sortParam : "gross";
  const order = searchParams.get("order") === "asc" ? "asc" : "desc";
  const keyword = searchParams.get("keyword") || "";
  const pageParam = parseInt(searchParams.get("page"), 10);
  const page = pageParam >= 1 ? pageParam : 1;

  const updateParams = useCallback(
    (patch) => {
      const next = new URLSearchParams(searchParams);
      Object.entries(patch).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") {
          next.delete(key);
        } else {
          next.set(key, String(value));
        }
      });
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return {
    tab, service, year, month, compareMode, compareYear,
    period, startDate, endDate, sort, order, keyword, page,
    updateParams,
  };
};

export default useSalesFilter;
